<template>
  <v-row align="start" class="row--35">
    <v-col lg="6" md="6" sm="12" cols="12" order="2" order-md="1">
      <div class="section-title text-left mb--50 mb_sm--30 mb_md--30">
        <h2 class="heading-title">let's talk.</h2>
        <p class="description">
          We are very sorry, <br /> but we are not accepting new clients at this time. 
        </p>
      </div>
      <div v-if="formEnabled">
        <div class="form-wrapper" v-if="!submitted && !submitError">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
              <ValidationProvider
                name="name"
                rules="required"
                v-slot="{ errors }"
              >
                <label>
                  <input
                    type="text"
                    v-model="formData.name"
                    placeholder="Your Name *"
                  />
                  <span class="inpur-error">{{ errors[0] }}</span>
                </label>
              </ValidationProvider>
  
              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <label>
                  <input
                    type="text"
                    rules="required|email"
                    v-model="formData.email"
                    placeholder="Your email *"
                  />
                  <span class="inpur-error">{{ errors[0] }}</span>
                </label>
              </ValidationProvider>
  
              <ValidationProvider
                name="phone"
                rules="required"
                v-slot="{ errors }"
              >
                <label>
                  <input
                    type="text"
                    v-model="formData.phone"
                    placeholder="Your phone *"
                  />
                  <span class="inpur-error">{{ errors[0] }}</span>
                </label>
              </ValidationProvider>
  
              <ValidationProvider
                name="message"
                rules="required"
                v-slot="{ errors }"
              >
                <label>
                  <textarea
                    v-model="formData.message"
                    placeholder="In a few words, describe what you are looking for."
                  ></textarea>
                  <span class="inpur-error">{{ errors[0] }}</span>
                </label>
              </ValidationProvider>
  
              <button
                class="rn-button-style--2 btn_solid"
                type="submit"
                value="submit"
              >
                {{ submitButton }}
              </button>
            </form>
          </ValidationObserver>
        </div>
        <div v-else-if="submitted && !submitError">
          Thank you for your message! We'll be in touch soon!
        </div>
        <div v-else>
          Error sending your message. Please try again later or email us directly at <a href="mailto:hello@studioone.dev">hello@studioone.dev</a>!
        </div>
      </div>
    </v-col>
    <v-col lg="6" md="6" sm="12" cols="12" order="1" order-md="2">
      <div class="mt--50 mb_md--40 mb_sm--40">
        <img src="../../assets/images/contact/plan.png" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import axios from 'axios';
  import { ValidationObserver } from "vee-validate";
  import { ValidationProvider } from "vee-validate/dist/vee-validate.full.esm";
  export default {
    components: {
      ValidationObserver,
      ValidationProvider,
    },
    data() {
      return {
        formEnabled: false,
        submitButton: "Submit", 
        submitted: false,
        submitError: false,
        formData: {
          name: "",
          email: "",
          phone: "",
          servicesNeeded: "",
          message: "",
        },
      };
    },
    methods: {
      onSubmit() {
        this.submitButton = "Submitting...";
        axios.post('https://us-central1-studioonefl.cloudfunctions.net/sendEmail', { name: this.formData.name, email: this.formData.email, phone: this.formData.phone, message: this.formData.message })
        .then(() => {
          this.submitted = true;
        })
        .catch((error) => {
          this.submitError = true;
          console.log(error);
        });
      },
    },
  };
</script>
